/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_PublishingInputs */

const vi_einvoice_publishing = /** @type {(inputs: Einvoice_PublishingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang phát hành hóa đơn`)
};

/**

* @param {Einvoice_PublishingInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_publishing = /** @type {((inputs?: Einvoice_PublishingInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_PublishingInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_publishing(inputs)
});